/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Ledgertime2Inputs */

const zh_adminsubs_ledgertime2 = /** @type {(inputs: Adminsubs_Ledgertime2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时间`)
};

const en_adminsubs_ledgertime2 = /** @type {(inputs: Adminsubs_Ledgertime2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time`)
};

const es_adminsubs_ledgertime2 = /** @type {(inputs: Adminsubs_Ledgertime2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hora`)
};

/**
* | output |
* | --- |
* | "Time" |
*
* @param {Adminsubs_Ledgertime2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_ledgertime2 = /** @type {((inputs?: Adminsubs_Ledgertime2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Ledgertime2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_ledgertime2(inputs)
	if (locale === "en") return en_adminsubs_ledgertime2(inputs)
	return es_adminsubs_ledgertime2(inputs)
});
export { adminsubs_ledgertime2 as "adminSubs_ledgerTime" }